export const servicesMock = {
  DOWNLOAD_DOCUMENT_BY_REFERENCE: true,
  SAVE_QUOTATION: true,
  RATER_CALCULATE_PRICE: true,
  SEND_BUDGET: true,
  CLICK_TO_CALL: true,
  AUTOCOMPLETE_CITY: true,
  AUTOCOMPLETE_STREET: false,
  NORMALIZE_ADDRESS: false,
  GET_POSTAL_CODES: true,
  POST_CP_CODES: true,
  GET_RECOVERY: false,
  MDW_GET_COVERAGES: false,
  REMOVE_PERIODS: false,
  MDW_GET_DOCUMENTS_BY_ROLE: false,
  DOWNLOAD_ACCORDION_DOCUMENT: false,
  GET_ACCORDION_DOCUMENTS: false,
  VALIDATE_EMAIL: false,
  SAVE_DOCUMENT: false,
  SAVE_HOLDER: false,
  SAVE_INSUREDS: false,
  SAVE_QUESTIONNAIRE: false,
  SAVE_PAYMENT: false,
  SING_DOCUMENT: false,
  POLICY_EMISSION: false,
  MDW_VALIDATE_LANDING: false,
  MDW_SEND_EMAIL_REQUEST: false,
  GET_INFO_MEDIATOR: true
}
